/*
This script continuously loads posts as the user scrolls the page. It uses the IntersectionObserver API to detect when the last post is in view, fetches the next page, and appends the posts (and dividers) to the feed. The last divider in the feed is hidden via CSS.
*/

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');
let loading = false;

// Fetch and parse next page; returns nodes to append (posts + dividers in order)
async function getNextPage(url) {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            throw new Error('Failed to fetch page')
        }

        const nextPageHtml = await res.text();
        const parser = new DOMParser();
        const parsed = parser.parseFromString(nextPageHtml, 'text/html');
        const feed = parsed.querySelector('.gh-postfeed');
        const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');

        const nodes = feed ? Array.from(feed.children) : [];

        return { nodes, nextLink }

    } catch (error) {
        throw new Error(error)
    }
}

function isLastPostInView(rootMargin = '150px') {
    const last = document.querySelector('.gh-postfeed .post:last-of-type');
    if (!last) return false;
    const rect = last.getBoundingClientRect();
    const margin = parseInt(rootMargin, 10) || 150;
    return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + margin;
}

export default function infiniteScroll() {

    const container = document.querySelector('.gh-postfeed');
    if (!container) { return; }

    if (!link) { return; }

    const rootMargin = '150px';
    const options = {
        rootMargin,
        threshold: 0,
    }

    function loadNext() {
        if (loading || !link) return;
        loading = true;
        const currentLink = link;
        link = null;

        getNextPage(currentLink).then(({ nodes, nextLink }) => {
            nodes.forEach(node => container.append(node));
            link = nextLink;
            loading = false;

            if (nextLink) {
                const newLast = container.querySelector('.post:last-of-type');
                if (newLast) observer.observe(newLast);
                // If the new last post is already in view, load more
                if (isLastPostInView(rootMargin)) {
                    window.requestAnimationFrame(() => loadNext());
                }
            } else {
                observer.disconnect();
            }
        }).catch(() => {
            link = currentLink;
            loading = false;
        });
    }

    const callback = (entries) => {
        try {
            entries.forEach(entry => {
                if (entry.isIntersecting && link && !loading) {
                    loadNext();
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    const observer = new IntersectionObserver(callback, options);
    const lastPost = container.querySelector('.post:last-of-type');

    if (lastPost) {
        observer.observe(lastPost);
        // If we're already scrolled so the last post is in view (e.g. restored scroll position), load immediately
        if (isLastPostInView(rootMargin)) {
            window.requestAnimationFrame(() => loadNext());
        }
    }
}
